import Model from "./Model";

export default class MediumAudience extends Model {
  static type = "mediumAudiences";

  name!: string;
  value!: number;
  townAreaId!: string;

  postalCode?: string;
  town?: string;
  district?: string;
  region?: string;
}
